import { render, staticRenderFns } from "./InquiryTable.vue?vue&type=template&id=376ec99e"
import script from "./InquiryTable.vue?vue&type=script&lang=js"
export * from "./InquiryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports